import { c as _c } from "react/compiler-runtime";
import { Input as InputPrimitive } from "@base-ui/react/input";
import * as React from "react";
import { cn } from "@v3/_/lib/utils";
function Input(t0) {
  const $ = _c(14);
  let className;
  let props;
  let style;
  let type;
  if ($[0] !== t0) {
    ({
      className,
      type,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = style;
    $[4] = type;
  } else {
    className = $[1];
    props = $[2];
    style = $[3];
    type = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("bg-input/20 dark:bg-input/30 border-input focus-visible:border-ring focus-visible:ring-ring/30 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 file:text-foreground placeholder:text-muted-foreground h-8 w-full min-w-0 rounded-md border px-2.5 py-1 text-sm transition-colors outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-xs/relaxed file:font-medium focus-visible:ring-[2px] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:ring-[2px] md:text-xs/relaxed", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== style) {
    t2 = style ? {
      style
    } : {};
    $[7] = style;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== props || $[10] !== t1 || $[11] !== t2 || $[12] !== type) {
    t3 = <InputPrimitive type={type} data-slot="input" className={t1} {...t2} {...props} />;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
    $[12] = type;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}
export { Input };